// scssコンパイルのために必須の記述
'use strict';
// import "../scss/style.scss";

//js import
import './intersectionObserver.js';
import './smoothScroll.js';
import './parallax.js';
import '@babel/polyfill';
import $ from 'jquery';

//ポリフィル
import objectFitImages from 'object-fit-images';
objectFitImages();

// import Stickyfill from "stickyfilljs"; //polyfill
// const sticky = document.querySelectorAll(".js-sticky");
// Stickyfill.add(sticky);

// ie識別・対策
const agent = window.navigator.userAgent.toLowerCase();
const isIE11 = agent.indexOf('trident/7') !== -1;

// メディアクエリ
const breakPointSp = 'max-width:1024px';
const isSP = () => {
  if (window.matchMedia(`(${breakPointSp})`)) {
    return true;
  } else {
    return false;
  }
};
// window.addEventListener('resize', isSP);
// window.addEventListener('load', isSP);

//横リサイズ・SP確認
const resizeCheckerSP = (callback) => {
  let lastInnerWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (lastInnerWidth != window.innerWidth) {
      let flag = isSP();
      if (flag == true) {
        callback();
      }
      lastInnerWidth = window.innerWidth;
    }
  });
};

//別ページからのアンカーずれ解消
document.addEventListener('DOMContentLoaded', () => {
  if (location.hash) {
    const headerHeight = document.getElementById('js-header').clientHeight;
    setTimeout(() => {
      window.scrollBy(0, -headerHeight);
    }, 100);
  }
});

/*
 * spグロナビ
 */
// ハンバーガーWAI-ARIA
const headerFnc = () => {
  const hamburger = document.getElementById('js-hamburger');
  const bodyClassList = document.body.classList;
  const hamburgerIcon = () => {
    const ariaExpanded = hamburger.getAttribute('aria-expanded');
    if (ariaExpanded == 'false') {
      hamburger.setAttribute('aria-expanded', 'true');
    } else {
      hamburger.setAttribute('aria-expanded', 'false');
    }
  };
  //bodyクラスで全体を管理
  const hamburgerBodyClass = () => {
    if (bodyClassList.contains('is-drawerActive')) {
      bodyClassList.remove('is-drawerActive');
    } else {
      bodyClassList.add('is-drawerActive');
    }
  };
  //リサイズ
  resizeCheckerSP(() => {
    hamburger.setAttribute('aria-expanded', 'false');
    bodyClassList.remove('is-drawerActive');
  });
  //clickイベント
  hamburger.addEventListener('click', () => {
    hamburgerIcon();
    hamburgerBodyClass();
    noScroll();
  });
  //spグロナビリンクをクリックで閉じる
  const spHeaderLinks = document.querySelectorAll('.HeaderSP_nav_list--item .item-link');
  spHeaderLinks.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      hamburgerIcon();
      hamburgerBodyClass();
    });
  });
};
headerFnc();

/*
 * target="_blank"にrel="noopener"を付与
 * 自分のドメイン、ハッシュは対象外
 */
const externalLink = function () {
  const thisSiteDomain = document.domain;
  const aTags = document.querySelectorAll('a:not([target="_blank"])');
  let array = [];
  if (!aTags.length) return;
  for (let i = 0; i < aTags.length; i++) {
    let aTag = aTags[i];
    let href = aTag.href;
    if (href.indexOf(`${thisSiteDomain}`) !== -1) continue; //自分のドメインは対象外
    aTag.setAttribute('target', '_blank');
    aTag.setAttribute('rel', 'noopener');
    array.push(aTag);
  }
  return array;
};
document.addEventListener('DOMContentLoaded', externalLink, false);

//レイヤー開いてるときはbodyスクロール禁止
const body = document.body;
const bodyClassList = body.classList;
const bodyStyle = body.style;
function noScroll() {
  if (bodyClassList.contains('noscroll')) {
    // レイヤーが閉じたら、topをscrollTopに
    let top = bodyStyle.top;
    bodyStyle.position = '';
    bodyStyle.top = '';
    window.scrollTo(0, parseInt(top || '0') * -1);
    bodyClassList.remove('noscroll');
  } else {
    bodyClassList.add('noscroll');
    // レイヤーが開いたら、bodyにfixedを付与
    bodyStyle.top = `-${window.scrollY}px`;
    bodyStyle.position = 'fixed';
  }
}
resizeCheckerSP(() => {
  bodyStyle.position = '';
  bodyStyle.top = '';
  bodyClassList.remove('noscroll');
});

const jobinfoTogglePC = () => {
  const trigger = $('.js-jobinfoPC-trigger');
  const targets = $('.js-jobinfoPC-content');
  const parentItem = $('.JobinfoPC--list_item');
  $('.js-jobinfoPC-content:not(.-active)').hide();
  $(trigger).on('click', function () {
    $(parentItem).removeClass('-active');
    $(targets).removeClass('-active').fadeOut();
    const num = $(this).attr('data-jobinfo-trigger');
    const target = $(`.js-jobinfoPC-content[data-jobinfo-content=${num}]`);
    $(this).parent(parentItem).addClass('-active');
    $(target).addClass('-active').fadeIn(1000);
  });
};
jobinfoTogglePC();

const jobinfoToggleSP = () => {
  const trigger = $('.js-jobinfoSP-trigger');
  const targets = $('.js-jobinfoSP-content');
  $(targets).hide();
  $(trigger).on('click', function () {
    const parentItem = $(this).parent('.js-jobinfoSP-item');
    if ($(parentItem).hasClass('-active')) {
      $(parentItem).removeClass('-active');
      $(this).siblings($(targets)).slideUp();
    } else {
      $(parentItem).addClass('-active');
      $(this).siblings($(targets)).slideDown();
    }
  });
  
  const close = $('.JobinfoSP--list_item--close');
  $(close).on('click', function () {
    const parentItem = $(this).parents('.js-jobinfoSP-item');
    $(parentItem).find($(targets)).hide();
    $(parentItem).removeClass('-active');
  });
};
jobinfoToggleSP();

//input[type="file"]の名前取得
$(function () {
  $('.entry--list_item.-file')
    .find($('.wpcf7-form-control-wrap'))
    .append('<span class="filename">選択してください</span>');
  $("input[type='file']").on('change', function () {
    const file = $(this).prop('files')[0];
    // if (!$('.filename').length) {
    //   $(this).parent($('.wpcf7-form-control-wrap')).append('<span class="filename"></span>');
    // }
    $('#input-label').addClass('changed');
    $(this).siblings($('.filename')).html(file.name);
  });
});
